import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilesComponent from 'components/files/files';
const QuestionTrueNFalse = ({ initialState, instructionsFile, getLocalAnswers }) => {
    const { t } = useTranslation();
    const [selectedAnswer, setSelectedAnswer] = useState(undefined);
    useEffect(() => {
        setSelectedAnswer(undefined);
        if (initialState === undefined || (initialState.userAnswer !== true && initialState.userAnswer !== false)) {
            return;
        }
        setSelectedAnswer(initialState.userAnswer);
    }, [initialState]);
    useEffect(() => {
        if (selectedAnswer === undefined) {
            return;
        }
        if ((initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer) === selectedAnswer) {
            return;
        }
        getLocalAnswers(selectedAnswer);
    }, [selectedAnswer]);
    return (_jsxs(_Fragment, { children: [_jsxs("form", Object.assign({ className: "form--student-exam" }, { children: [_jsxs("fieldset", Object.assign({ className: "fieldset--radio" }, { children: [_jsx("legend", Object.assign({ className: 'd-none' }, { children: "Answer Option" }), void 0), _jsx("input", { type: "radio", name: "question", id: "true", checked: selectedAnswer === true, onChange: () => setSelectedAnswer(true) }, void 0), _jsx("label", Object.assign({ htmlFor: "true" }, { children: t('QUESTION.TRUE_FALSE.TRUE') }), void 0)] }), void 0), _jsxs("fieldset", Object.assign({ className: "fieldset--radio" }, { children: [_jsx("legend", Object.assign({ className: 'd-none' }, { children: "Answer Option" }), void 0), _jsx("input", { type: "radio", name: "question", id: "false", checked: selectedAnswer === false, onChange: () => setSelectedAnswer(false) }, void 0), _jsx("label", Object.assign({ htmlFor: "false" }, { children: t('QUESTION.TRUE_FALSE.FALSE') }), void 0)] }), void 0)] }), void 0), instructionsFile && (_jsx(FilesComponent, { file: instructionsFile }, void 0))] }, void 0));
};
export default QuestionTrueNFalse;
